/** Normalizes legacy and v2 Sportsnew fixture-patch payloads for one consumer path. */

export const SPORTSNEW_FIXTURE_PATCH_CONTRACT_V2 = 2;

const normalizeFixtureIdentity = (value) => {
  if (value == null) return null;
  const normalized = String(value).trim();
  return normalized || null;
};

export const sportsnewFixturePatchId = (patch = {}) => normalizeFixtureIdentity(
  patch?.fixtureId
    ?? patch?.fixture_id
    ?? patch?.fixture?.fixtureId
    ?? patch?.fixture?.fixture_id
    ?? patch?.fixture?.id,
);

export const sportsnewFixturePatchMatchesFixture = (patch, fixtureId) => {
  const patchFixtureId = sportsnewFixturePatchId(patch);
  const activeFixtureId = normalizeFixtureIdentity(fixtureId);
  return patchFixtureId != null
    && activeFixtureId != null
    && patchFixtureId === activeFixtureId;
};

export const normalizeSportsnewFixturePatchContract = (patch = {}) => {
  if (!patch || typeof patch !== 'object' || Array.isArray(patch)) return {};
  const marketSnapshot = Array.isArray(patch.marketSnapshot) ? patch.marketSnapshot : null;
  if (!marketSnapshot) return patch;
  return {
    ...patch,
    markets: marketSnapshot,
    projectionScope: patch.projectionScope ?? patch.projection_scope ?? 'full',
    isFullFixtureProjection: true,
  };
};
